import React from 'react';
import Main from './page/index/main/Main';
import Header from './page/index/header/Header';
import Footer from './page/index/footer/Footer';
import './App.css';

function App() {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
}

export default App;
